// GET_CLIENTS already loads the whole section tree into the sites module: state.sites is keyed by site
// uuid, each site carries its client_uuid and a flat list of its descendant sections with a parent_uuid.
// Walking that data upward yields a section's ancestry without another API call.
export const sectionLineage = (sites, uuid) => {
    if (!uuid) {
        return [];
    }

    const parentOf = {};
    Object.values(sites || {}).forEach((site) => {
        if (site.client_uuid) {
            parentOf[site.uuid] = site.client_uuid;
        }
        (site.sections || []).forEach((section) => {
            if (section.parent_uuid) {
                parentOf[section.uuid] = section.parent_uuid;
            }
        });
    });

    const lineage = [];
    // seen doubles as the cycle guard: malformed section data with a parent loop stops here rather than
    // spinning. It is a Set rather than a scan of lineage so the walk stays linear in the lineage length.
    const seen = new Set();
    let current = uuid;
    while (current && !seen.has(current)) {
        seen.add(current);
        lineage.push(current);
        current = parentOf[current];
    }
    return lineage;
};
